import React from "react";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import NearMeIcon from "@material-ui/icons/NearMe";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExpandMoreOutlined from "@material-ui/icons/ExpandMoreOutlined";
import { Avatar } from "@material-ui/core";
import "./post.css";

const Post = ({ profilePic, message, timestamp, imgName, username }) => {
  return (
    <div className="post__wrapper">
      <div className="post-top">
        <Avatar src={profilePic} className="profile__avatar" />
        <div className="post__topInfo">
          <h3>{username}</h3>
          <p>{new Date(parseInt(timestamp)).toUTCString()}</p>
        </div>
      </div>
      <div className="post-buttom">
        <p>{message}</p>
      </div>
      {imgName ? (
        <div className="post__image">
          <img
            src={`https://vidly-backend-hn1a.onrender.com/images/
single?name=${imgName}`}
            alt="Posts"
          />
        </div>
      ) : (
        console.log("DEBUG >>> no image here")
      )}
      <div className="post-option">
        <div className="post__option">
          <ThumbUpIcon />
          <p>Like</p>
        </div>
        <div className="post__option">
          <ChatBubbleOutlineIcon />
          <p>Comment</p>
        </div>
        <div className="post__option">
          <NearMeIcon />
          <p>Share</p>
        </div>
        <div className="post__option">
          <AccountCircleIcon />
          <ExpandMoreOutlined />
        </div>
      </div>
    </div>
  );
};

export default Post;
